document.addEventListener('DOMContentLoaded', () => {
    
    const iframe = document.querySelector('iframe'),
          player = new Vimeo.Player(iframe),
          sound = document.querySelector('.js-sound');

    player.on('play', function() {
        iframe.classList.add('is-visible')
        document.querySelector('.c-hero').querySelector('.loader').style.display = 'none';
    });
    
    sound.addEventListener('click', function(e) {        
        sound.classList.toggle('icon-sound-on');
        
        if (sound.classList.contains('icon-sound-off')) {
            player.setVolume(1);
            sound.classList.toggle('icon-sound-off')
            sound.classList.add('icon-sound-on')
        } else {
            player.setVolume(0);
            sound.classList.toggle('icon-sound-off')
            sound.classList.remove('icon-sound-on')
        }        
    })
    
}, false);